import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
  IconButton,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./PackageItemsDetailsDialog.scss";
import templeIcon from "../../assets/temple-icon.png";
import pujaIcon from "../../assets/puja-name-icon.png";
import ShowMoreShowLess from "../ShowMoreShowLess/ShowMoreShowLess";
import ImageView from "../ImageView/ImageView";

interface PackageItemsDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  packageImage: string;
  templeName: string;
  pujaName: string;
  packageDescription: string;
  templeIcon?: any;
  templeAddress?: any;
  itemOrderType?: any;
  onClickAddPuja?: () => void;
}

const PackageItemsDetailsDialog: React.FC<PackageItemsDetailsDialogProps> = ({
  open,
  onClose,
  packageImage,
  templeName,
  pujaName,
  packageDescription,
  templeAddress,
  onClickAddPuja,
}) => {
  return (
    <Dialog
      open={open}
      className="packageModelStyle"
      fullWidth
      maxWidth="sm"
      onClose={onClose}
    >
      <Box className="dilogClose">
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent>
        <Box className="topSection">
          <Box className="packageImageWrapper">
            <ImageView
              src={packageImage}
              alt="Package"
              className="packageImage"
            />
          </Box>

          <Box className="templeInfo">
            <Box className="templeNameWrapper">
              <Avatar
                alt="Temple Icon"
                className="templeIcon"
                sx={{ bgcolor: "transparent" }}
              >
                <img src={templeIcon} alt="Temple Icon" />
              </Avatar>
              <Typography variant="subtitle1" className="templeName">
                {templeName}
                {", "}
                {templeAddress}
              </Typography>
            </Box>

            <Box className="templeNameWrapper">
              <Avatar
                alt="Puja Icon"
                className="templeIcon"
                sx={{ bgcolor: "transparent" }}
              >
                <img src={pujaIcon} alt="Puja Icon" />
              </Avatar>
              <Typography variant="subtitle2" className="pujaName">
                {pujaName}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className="descriptionBox scrollableSection">
          <Typography variant="body2" className="bottomDescription">
            <ShowMoreShowLess text={packageDescription} limit={120} />
          </Typography>
        </Box>
        {/* <Box className="visitButton">
          <Button variant="contained" color="primary" onClick={onClickAddPuja}>
            {t(LOCALIZATION.Visit)}
          </Button>
        </Box> */}
      </DialogContent>
    </Dialog>
  );
};

export default PackageItemsDetailsDialog;
